<style lang="less">
#peopleSel {
  .ivu-layout-sider {
    width: 175px;
  }
  .allArea {
    height: 250px;
    border-bottom: 1px solid #dbdfe0;
    overflow-y: auto;
  }
  .selectArea {
    width: 460px;
    height: 50px;
  }
  .ivu-layout-footer {
    padding: 0px;
  }
  .ivu-layout-sider {
    background-color: #f3f3f3;
  }
  .ivu-collapse button {
    width: 100px;
  }
  .select-btn {
    margin: 5px;
  }
}
#beforePeople .ivu-modal-mask {
  z-index: 1100 !important;
}
#beforePeople .ivu-modal-wrap {
  z-index: 1100 !important;
}
</style>
<template>
	<div id="peopleSel">
		<Layout>
			<Sider hide-trigger>
				<Collapse accordion>
					<Panel name="1">
						本部门选择
						<p slot="content">
							<Button type="text" @click="peopleChange2">本部门选择</Button>
						</p>
					</Panel>
					<Panel name="2">
						其他部门
						<p slot="content" style="max-height:175px;overflow-y: auto">
							<template v-for="(item,key) in otherCompany">
								<Button type="text" @click="peopleChange(item)">{{item}}</Button>
							</template>
						</p>
					</Panel>
				</Collapse>
			</Sider>
			<Layout>
				<Content>
					<div class="allArea">
						<template v-if="!InfoIUsers.ListUser">
							<Button class="select-btn" type="success" size="small">流程结束</Button>
						</template>
						<template v-else>
							<template v-for="(item,key) in otherPeople">
								<Button class="select-btn" type="success" size="small" @click="selectPeople(item.UserId,item.RealName)">{{item.RealName}}</Button>
							</template>
						</template>
					</div>
				</Content>
				<Footer>
					<div class="selectArea">
						<template v-if="!InfoIUsers.ListUser">
							<!-- <Button class="select-btn" type="success" size="small">流程结束</Button> -->
							流程结束
						</template>
						<template v-else>
							<span v-if="thisPeopleObj.userName">当前选择人员：{{thisPeopleObj.userName}}</span>
						</template>
					</div>
				</Footer>
			</Layout>
		</Layout>

	</div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'

export default {
	props: ['childMsg'],
	data() {
		return {
			// wfUrl: 'http://qy.chinapsp.cn:45100/',
			wfUrl: location.href.indexOf('qy.chinapsp.cn') != -1 ? 'http://qy.chinapsp.cn:45100':'http://192.168.166.141:8886',
			InfoIUsers: {
				ListUser: "",
				NextActivityCode: "",
				NextActivityName: ""
			},
			InfoIUserList: [],
			myPeople: [],
			otherPeople: [],
			otherCompany: [],
			otherCDU: {
			},
			thisPeopleObj: {
				userId: "",
				userName: "",
				NextActivityCode: "",
				NextActivityName: ""
			},
		}
	},
	watch: {
		async childMsg(val) {
			var self = this;
			self.doreset();
			self.InfoIUsers = val;
			// axios.get('http://qy.chinapsp.cn:8082/cailian/fr/userInfo/getUserInfoByNameJ', {
			// 	params: {
			// 		username: this.$store.state.session.user.name
			// 	}
			// }).then(res => {

			// 	self.InfoIUsers.company = res.data.details.tempDertpart
			// 	self.InfoIUsers.department = ''
			// 	if (res.data.details.dqjm) {
			// 		self.InfoIUsers.department = res.data.details.dqjm.department
			// 	}

			// 	self.doSplitPeople();
			// })

			let rep =  await ajax.get(requestUrls.OrganizationUnitOpen.GetOrganizationUnitsByUserid, {
				params: {
					user_id: this.$store.state.session.user.id
				}
			})
			self.InfoIUsers.company = ''
			self.InfoIUsers.department = ''
			if (rep.data.success && rep.data.result.items.length > 0) {
				rep.data.result.items.forEach(item => {
					self.InfoIUsers.department += `,${item.displayName}`
				})
				self.InfoIUsers.department = self.InfoIUsers.department.slice(1)
				self.InfoIUsers.company = self.InfoIUsers.department
			}
			self.doSplitPeople()
		}
	},
	methods: {
		doreset() {
			this.InfoIUsers = {
				ListUser: "",
				NextActivityCode: "",
				NextActivityName: ""
			};
			this.InfoIUserList = [];
			this.myPeople = [];
			this.otherPeople = [];
			this.otherCompany = [];
			this.otherCDU = {
			};
			this.thisPeopleObj = {
				userId: "",
				userName: "",
				NextActivityCode: "",
				NextActivityName: ""
			};
		},//重置选人区域
		peopleChange2() {
			var self = this;
			self.otherPeople = self.myPeople;
		},
		peopleChange(item) {
			var self = this;
			self.otherPeople = self.otherCDU[item];
		},
		selectPeople(userid, username) {
			var self = this;
			self.thisPeopleObj.userId = userid;
			self.thisPeopleObj.userName = username;
			self.$emit('toparentevent', self.thisPeopleObj);
		},
		getUsers(obj) {
			// var self = this;
			// axios({
			//     method:"post",
			//     url:self.wfUrl + "WorkflowBusinessRESTfullApi/GetActivityInfoIUsers",
			//     data:qs.stringify(obj)
			// }).then((res)=>{
			//     if(res.data.length == 1){
			//         self.InfoIUsers = res.data[0];    
			//         self.thisPeopleObj.NextActivityCode = res.data[0]["NextActivityCode"];
			//         self.thisPeopleObj.NextActivityName = res.data[0]["NextActivityName"];
			//         if(!!self.InfoIUsers.ListUser){
			//             self.doSplitPeople();
			//         }
			//         else{
			//             self.$emit('toparentevent',self.thisPeopleObj);  
			//         } 
			//     }  
			//     else{
			//         self.InfoIUserList = res.data;
			//     } 
			// }); 
		},
		doSelectNext(num) {
			// var self = this;
			// self.InfoIUsers = self.InfoIUserList[num];
			// self.thisPeopleObj.NextActivityCode = self.InfoIUserList[num]["NextActivityCode"];
			// self.thisPeopleObj.NextActivityName = self.InfoIUserList[num]["NextActivityName"];
			// self.doSplitPeople();
			// self.beforePeopleDialogVisible = false;
		},//分支选择并弹出选人对话框
		doSplitPeople() {
			var self = this;
			var param = {
				company: "",
				department: ""
			}
			self.myPeople = [];
			self.otherCompany = [];
			self.otherCDU = {};
			// 有待处理
			param.company = self.InfoIUsers.department;
			param.department = self.InfoIUsers.department;
			if (self.InfoIUsers.company.indexOf("广州分公司") !== -1) {
				param.company = self.InfoIUsers.company;
				param.department = self.InfoIUsers.department;
			}
			else {
				param.company = self.InfoIUsers.company;
				param.department = self.InfoIUsers.company;
			}
			// 去除重复人物
			let hadPushed = []
			if (self.InfoIUsers.ListUser) {
				for (var i = 0; i < self.InfoIUsers.ListUser.length; i++) {
					var thisObj = self.InfoIUsers.ListUser[i];
					if (param.department.indexOf(thisObj.OrgName) !== -1 && hadPushed.indexOf(thisObj.UserId) === -1) {
						hadPushed.push(thisObj.UserId)
						self.myPeople.push({
							UserId: thisObj.UserId,
							RealName: thisObj.RealName
						})
					}
					var index = self.otherCompany.findIndex((value, index, arr) => {
						return value == thisObj.OrgName;
					});
					if (index < 0) {
						self.otherCompany.push(thisObj.OrgName);
						self.otherCDU[thisObj.OrgName] = [];
					}
					self.otherCDU[thisObj.OrgName].push({
						UserId: thisObj.UserId,
						RealName: thisObj.RealName
					});
				}
			}
			self.otherPeople = self.myPeople;
		},
	}
}
</script>
